import { useService } from '@aesop-fables/containr-react';
import { TermsApi } from '../api/apis/TermsApi';
import { ApiKeys } from '../api/apis/ApiKeys';
import { useEffect, useState } from 'react';

const useTermsOfServiceDocs = () => {
  const [terms, setTerms] = useState<string>('');

  const termsApi = useService<TermsApi>(ApiKeys.Terms);

  useEffect(() => {
    const getTermsLink = async () => {
      const docs = await termsApi.getAll();
      const termsOfServiceDoc = docs.data.find(doc => doc.docDescription === 'Terms of Service');
      if (!termsOfServiceDoc) {
        return;
      }
      const termsOfServiceUrl = termsApi.get(termsOfServiceDoc.id);
      setTerms(termsOfServiceUrl);
    };

    getTermsLink();
  }, [termsApi]);

  return terms;
};

export default useTermsOfServiceDocs;
